module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"total_reviews_count":"{0} reviews"}}')
  delete Component.options._Ctor
}
